"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var cashSummaryBlocksStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        title: {
            fontFamily: typography.fontFamily2,
            fontWeight: typography.fontWeightBold,
        },
        cashSummaryBlocksWrapper: {
            fontFamily: typography.fontFamily,
        },
        divider: {
            margin: '0 5px',
        },
        element: {},
        price: {},
        cashSummaryBlocks: {},
    });
}, { name: 'GqlSummary_CashSummaryBlocks' });
exports.default = cashSummaryBlocksStyles;
